import * as React from 'react';
import * as ReactDom from 'react-dom';
import { BookingForm } from './bookingForm';
import { BookingFormSettings } from './mrCapTypes';

function MainComponent(settings: BookingFormSettings) {
  return <BookingForm {...settings} />;
}

(window as any).mrCap = {
  booking(element: string, settings: BookingFormSettings) {
    const elm = document.querySelector(element);

    if (!elm) {
      throw `Element ${elm} could not be found`;
    }

    ReactDom.render(<MainComponent {...settings} />, elm);
  }
};
